import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { merchantEndpoints } from "@/features/merchant/api/endpoints";
import type {
  MerchantSaleDto,
  MerchantSaleFilter,
} from "@/features/merchant/api/dto";

/**
 * Liste paginée des ventes marchandes
 * (`POST /MerchantSales/all` — les listes sont en POST, §4.2).
 */
export const useMerchantSales = (
  params: ListRequest<MerchantSaleFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.MERCHANT_SALES_LIST(params),
    queryFn: () =>
      mutateData({
        url: merchantEndpoints.merchantSales.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<MerchantSaleDto>>,
    enabled,
  });
